export function PageHeader({ title, kicker, description, actions }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div>
        {kicker && <div className="text-[10px] uppercase tracking-[0.2em] font-mono font-semibold text-cyan-700 mb-2">{kicker}</div>}
        <h1 className="font-display font-extrabold text-3xl md:text-4xl text-slate-900 tracking-tight" data-testid="page-title">{title}</h1>
        {description && <p className="text-slate-600 mt-2 text-sm max-w-2xl">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, cta }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center rounded-xl border border-dashed border-slate-300 bg-white/50" data-testid="empty-state">
      {Icon && <div className="h-12 w-12 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center mb-4"><Icon className="h-5 w-5" /></div>}
      <div className="font-display font-semibold text-slate-900 text-lg">{title}</div>
      {description && <div className="text-sm text-slate-500 max-w-md mt-1">{description}</div>}
      {cta && <div className="mt-5">{cta}</div>}
    </div>
  );
}

export function LoadingSkeleton({ rows = 6 }) {
  // Skeleton items are pure placeholders with no local state — a stable
  // string key keyed off the row index is sufficient and satisfies react/no-array-index-key.
  return (
    <div className="space-y-3" data-testid="loading-skeleton">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={`skeleton-row-${i}`} className="h-12 rounded-lg bg-slate-100 animate-pulse" />
      ))}
    </div>
  );
}

export function DeniedState({ requiredRoles = [] }) {
  return (
    <div className="max-w-md mx-auto py-16 px-6 text-center" data-testid="denied-state">
      <div className="h-14 w-14 mx-auto rounded-full bg-slate-100 flex items-center justify-center mb-4 text-slate-400 font-mono">🔒</div>
      <div className="font-display text-xl font-semibold text-slate-900">Access denied</div>
      <div className="text-sm text-slate-500 mt-2">Your role does not permit this action. Ask an admin to grant one of: <span className="font-mono font-semibold text-slate-700">{requiredRoles.join(", ")}</span>.</div>
    </div>
  );
}
